// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/School/List/index.less
// module id = 905
// module chunks = 0